export type Platform = "steam" | "playstation" | "xbox" | "nintendo" | "epicgames" | "discord";
export const PLATFORMS: Platform[] = ["discord", "epicgames", "nintendo", "playstation", "steam", "xbox"];
